<template>
    <div class="quote-panel">

        <button type="button" class="quote-toggler" @click="toggleCollapsed"><span class="quote-toggler-icon" :class="{ open: !collapsed }"></span></button>


            <div class="quote-header" :class="{ 'quote-collapsed': collapsed }">
                <div class="pr-2">
                    <h2 class="mb-0">{{ addressFull }}</h2>
                </div>

                <div class="cta-toggle">
                    <button type="button" class="toggle left" :class="{ highlight: !showWeekly }" @click="showWeekly = false">£ Monthly</button><button type="button" class="toggle right" :class="{ highlight: showWeekly }" @click="showWeekly = true">£ Weekly</button>
                </div>

            </div>


            <div class="quote-panel-bills" :class="{ 'quote-collapsed': collapsed }">
                <div v-for="bill in selectedBills" :key="bill.id">
                    <div class="quote-panel-bill d-flex">

                        <div v-if="bill.group.name === 'Billing Better Service'" class="d-flex flex-grow-1 flex-column justify-content-center pr-4">
                            <div class="font-weight-bold">{{ bill.group.name }}</div>
                        </div>

                        <div v-else class="d-flex flex-grow-1 flex-column justify-content-center">
                            <div class="font-weight-bold">{{ bill.group.name }}</div>
                            <div class="price-notice">
                                <small v-if="bill.group.id !== 4 && bill.group.id !== 8">{{ bill.provider.name }}</small><small v-if="bill.group.id === 5"> • {{ bill.name }}</small>
                            </div>
                            <div v-if="bill.group.id === 4" class="flex pr-2">
                                <small class="price-notice">
                                    By including TV License, your <strong>first</strong> monthly payment will be higher
                                </small>
                                <span
                                    class="info-icon"
                                    :title="`Instead of being charged £${bill.prices[0].price_per_housemate} for TV Licence, your first monthly payment will be £${tvLicenseCost}. After you've made your first monthly payment for your bills package, your monthly payments will drop back down to £${bill.prices[0].price_per_housemate} for TV Licence (the amount shown in the quote). The reason your first payment is higher is because the TV Licence company charge in quarterly installments rather than monthly.`"
                                > ? </span>
                            </div>
                        </div>

                        <div class=" bill-price">
                            £{{ calculateDurationPrice(bill.prices[0].price_per_housemate) }}/{{ durationLabel }}
                            <div class="bill-price-sub">per housemate</div>
                        </div>
                    </div>

                    <hr>
                </div>
            </div>


        <div class="quote-panel-total d-flex">
            <div class="total-text flex-grow-1 font-weight-bold">Total</div>

            <div class="total-prices">
                <div class="price-housemate">
                    <div>
                        <span class="font-weight-bold">£{{ priceBillPayer }}/{{ durationLabel }}</span>
                    </div>
                    <div class="total-price-sub">per bill payer</div>
                </div>

                <div class="price-household" :class="{ 'quote-collapsed': collapsed }">
                    <div>
                        <span>£{{ priceTotal }}/{{ durationLabel }}</span>
                    </div>
                    <div class="total-price-sub">Total cost for
                        <span v-if="housemates > 1">{{ housemates}} housemates</span>
                        <span v-else>{{ housemates }} housemate</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="quote-panel-total mt-4 cta-quote">
            <slot></slot>
        </div>

    </div>
</template>

<script>
    import store from "../../store";

    export default {
        name: "QuotePanel",

        props: {
            'housemates' : {
                type: Number,
                required: true
            },
            'billPayers' : {
                type: Number,
                required: true
            },
            'addressFull' : {
                type: String,
                required: true
            },
        },

        data() {
            return {
                collapsed: true,
                showWeekly: false, // False is monthly
            }
        },

        methods: {
            toggleCollapsed: function() {
                this.$data.collapsed = !this.$data.collapsed;
            },

            calculateDurationPrice(price) {
                if(this.$data.showWeekly) {
                    return ((price * 12) / 52).toFixed(2);
                } else {
                    return parseFloat(price).toFixed(2);
                }
            }
        },

        computed: {
            priceHousemate: function() {
                return this.calculateDurationPrice(this.$store.getters['quote/getPriceHousemate']);
            },

            priceBillPayer: function() {
                return (this.priceTotal / this.$props.billPayers).toFixed(2);
            },

            priceTotal: function() {
                return (this.priceHousemate * this.$props.housemates).toFixed(2);
            },

            selectedBills: function() {
                return this.$store.getters['quote/getSelectedBills'];
            },

            tvLicense() {
                return this.selectedBills.find(bill => bill.group_id === 4)
            },

            tvLicenseCost() {
                if (!this.tvLicense) {
                    return 0;
                }
                const housemates = this.tvLicense.prices[0].housemates
                const price = 41 / housemates
                return price.toFixed(2)
            },

            durationLabel: function() {
                if(this.$data.showWeekly) {
                    return 'week';
                } else {
                    return 'month';
                }
            }
        }
    }
</script>
